import { render, staticRenderFns } from "./docenteHome.vue?vue&type=template&id=74f73074&scoped=true"
import script from "./docenteHome.vue?vue&type=script&lang=js"
export * from "./docenteHome.vue?vue&type=script&lang=js"
import style0 from "./docenteHome.vue?vue&type=style&index=0&id=74f73074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f73074",
  null
  
)

export default component.exports